import { ExclusiveTypeEnum, JobOptionSvcGroup } from 'domains/jobconfigDomain';
import { Fragment } from 'react';
import AnyOfSvcs from './AnyOfSvcs';
import OneOfSvcs from './OneOfSvcs';

type Props = {
  svcGroups?: JobOptionSvcGroup[];
  [x: string]: any;
};

const RevxSvcContent = ({ svcGroups, ...props }: Props) => {
  return (
    <>
      {svcGroups?.map((svcGroup, idx) => {
        return (
          <Fragment
            key={`${svcGroup.exclusiveType}-${svcGroup.svcs.length}-${idx}`}
          >
            {svcGroup.exclusiveType === ExclusiveTypeEnum.ANY_OF && (
              <AnyOfSvcs {...props} svcGroup={svcGroup} />
            )}
            {svcGroup.exclusiveType === ExclusiveTypeEnum.ONE_OF && (
              <OneOfSvcs {...props} svcGroup={svcGroup} />
            )}
          </Fragment>
        );
      })}
    </>
  );
};

export default RevxSvcContent;
